import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'ef-quick-access',
    templateUrl: './quick-access.component.html',
    styleUrls: ['./quick-access.component.scss'],
    standalone: false
})
export class QuickAccessComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
